
import { css } from 'lit';
export default css`
pc-basic-hero img{
  width:100%;
  max-height:310px;
  object-fit:cover;
  max-width:515px;
  z-index:1;
  position:relative;
}

@media (max-width: 1023px){
  pc-basic-hero img{
    display:none;
  }
}

pc-basic-hero pc-animation{
    width:unset;
    position:absolute;
    top:0;
    right:0;
  }

pc-basic-hero .animate{
    stroke-dasharray:var(--line-length);
    stroke-dashoffset:var(--line-length);
    animation:dash 1.5s linear forwards;
  }

@keyframes dash{
    from{
      stroke-dashoffset:var(--line-length);
    }
    to{
      stroke-dashoffset:0;
    }
  }

pc-basic-hero .heading-h6, pc-basic-hero .heading-h2{
    height:25%;
    transition:height linear .4s;
    overflow:hidden;
  }

pc-basic-hero [slot="nav"]{
    display:flex;
    column-gap:1rem;
    align-items:center;
  }

pc-basic-hero[loaded='loaded'] .heading-h6, pc-basic-hero[loaded='loaded'] .heading-h2{
    height:100%;
  }

`;